export class DeviceConsumption {
    dayValue?: number;
    monthValue?: number;
    yearValue?: number;
    accumulatedValue?: number;
    unity: string;
}